import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createProvidentFund = createAsyncThunk(
  'providentFund/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/provident-fund', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create record');
    }
  }
);

// Get All
export const fetchAllProvidentFunds = createAsyncThunk(
  'providentFund/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/provident-fund');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch records');
    }
  }
);

// Get By ID
export const fetchProvidentFundById = createAsyncThunk(
  'providentFund/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/provident-fund/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch record');
    }
  }
);

// Update
export const updateProvidentFund = createAsyncThunk(
  'providentFund/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/provident-fund/${id}`, data);
      return { id, data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update record');
    }
  }
);

// Delete
export const deleteProvidentFund = createAsyncThunk(
  'providentFund/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/provident-fund/${id}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to delete record');
    }
  },
  
);
// Fetch Monthly Summary
export const fetchPFMonthlySummary = createAsyncThunk(
  'providentFund/fetchMonthlySummary',
  async ({ year, month }: { year: number; month: number }, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/provident-fund/summary/${year}/${month}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch summary');
    }
  }
);

